import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment, { isMoment } from 'moment-timezone';
import { range } from 'ramda';

/**
 * Creates an an object with an empty array of date keys. I.e. { 1539057600: [], 1539144000: [], ... }
 * @param days is how many days ahead you want to create the empty dates object for.
 * For example, if you want to do 14 days total (2 weeks), you should execute `emptyDatesObject(13)`
 * We are using 13 instead of 14 because 0 starts on today
 */
export var emptyDatesObject = function emptyDatesObject(days) {
  var listOfDates = range(0, days + 1).map(function (v) {
    return toNowTime().startOf('day').add(v, 'day').unix().toString();
  });
  return listOfDates.reduce(function (acc, val) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, val, []));
  }, {});
};
export var toNowTime = function toNowTime() {
  return moment();
}; // tz.guess produces a string such as [America/Montreal] based on JS internationization api

export var toNowTimezoneString = function toNowTimezoneString() {
  return "".concat(moment().format(), "[").concat(moment.tz.guess(), "]");
};
export var toGuessedUTCTimezone = function toGuessedUTCTimezone() {
  return moment().tz(moment.tz.guess()).format('z');
};
export var toTime = function toTime(timestamp) {
  var isMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isMoment(timestamp)) {
    return timestamp;
  }

  if (typeof timestamp === 'number') {
    return isMilliseconds ? moment(timestamp) : moment.unix(timestamp);
  }

  if (typeof timestamp === 'string') {
    if (new Date(timestamp).toString() === 'Invalid Date') {
      return moment.invalid();
    } //This is to bypass the warnings caused by https://momentjs.com/guides/#/warnings/js-date/
    //by specifying the formats we are sending into moment


    var usedFormats = ['YYYY-MM-DD', 'MMMM DD, YYYY', 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ', 'YYYY-MM-DD LTS', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DDTHH:mm:ssZ', 'MMMM DD, YYYY HH:mm:ss [GMT]Z'];
    return moment(timestamp, usedFormats);
  }

  return moment(timestamp);
};
export var toUtcTime = function toUtcTime(timestamp) {
  return moment.utc(toTime(timestamp));
};
export var toTimeWithZone = moment.parseZone;
export var toMaybeTime = function toMaybeTime(timestamp) {
  var isMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return timestamp ? toTime(timestamp, isMilliseconds) : toInvalidTime();
};
export var toTimeWith = function toTimeWith(opts) {
  return moment(opts);
};
export var toTimeFromDate = function toTimeFromDate(date) {
  return toTime(Math.round(date.getTime() / 1000));
};
export var toUtcTimeFromDate = function toUtcTimeFromDate(date) {
  var dateAsMoment = moment(date);
  var utcDate = dateAsMoment.add(dateAsMoment.utcOffset(), 'minutes').toDate(); // moment currently doesn't have a straightforward way to get the utc time, so we have to offset it manually

  return toTimeFromDate(utcDate);
};
export var toTimeFromString = function toTimeFromString(dateString) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment.ISO_8601;
  return moment(dateString, format);
};
export var toInvalidTime = function toInvalidTime() {
  return moment.invalid();
};
export var isTime = function isTime(maybeTime) {
  return moment.isMoment(maybeTime);
};
export var isTimeValid = function isTimeValid(maybe) {
  return isTime(maybe) && maybe.isValid();
};
export var toDiffDuration = function toDiffDuration(startTime, endTime) {
  return moment.duration(endTime.diff(startTime));
};
export var setDisplayLanguage = function setDisplayLanguage(displayLanguage) {
  return moment.locale(displayLanguage);
};
export var guessTimeZone = function guessTimeZone() {
  return moment.tz.guess();
};
export var isValidDateFormatValue = function isValidDateFormatValue(dateFormatValueToTest, dateFormat) {
  return moment(dateFormatValueToTest, dateFormat, true).isValid();
};
export var dateObjectWithDateFormat = function dateObjectWithDateFormat(dateValue, dateFormat) {
  return moment(dateValue, dateFormat, true);
}; //asdfs